export const css = {
	root: '_27NxZbSD',
	' _key': 'apic-theme/dojo/variants/default'
};

export default css;
